import React from 'react';
import { contactInfo } from '../data/mockData';

const AboutSection = () => {
  return (
    <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #0A0015, #1A0520)' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Über die Saale Lounge
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full mb-8" />
        </div>
        
        <div className="glass-card p-8 md:p-12">
          <div className="space-y-6">
            {/* Willkommen */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Willkommen in der Saale Lounge
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Tauchen Sie ein in unsere einzigartige Cocktail- und Weinbar, wo stilvoll eingerichtete Räume auf eine gemütliche Atmosphäre treffen. Unsere Bar erstreckt sich über großzügige 200 Quadratmeter und ist der perfekte Ort, um entspannte Stunden mit Freunden oder der Familie zu verbringen.
              </p>
            </div>

            {/* Cocktails */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Cocktails – Das Herzstück des Hauses
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Die Leidenschaft für Cocktails ist unser Antrieb. Mit einer vielfältigen Auswahl an verschiedensten Cocktails, die von unserem Team liebevoll zubereitet werden, bieten wir Ihnen unvergessliche Geschmackserlebnisse. Ob klassisch oder kreativ interpretiert – wir haben für jeden Gaumen den richtigen Drink parat.
              </p>
            </div>

            {/* Regionale Weine */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Regionale Weine aus Hammelburg
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Besonders stolz sind wir auf unsere erlesene Auswahl an regionalen Hammelburger Weinen. Genießen Sie die feinen Tropfen der Winzer, die perfekt zu unserem vielseitigen Angebot passen. Natürlich können Sie auch für Zuhause Ihren Weinbedarf eindecken.
              </p>
            </div>

            {/* Liebe zum Detail */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Liebe zum Detail
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Jeder Aspekt unserer Bar ist mit viel Liebe zum Detail gestaltet. Von der Einrichtung bis hin zur Präsentation unserer Getränke und Speisen – wir möchten, dass Sie sich bei uns rundum wohlfühlen. Wir bringen Ihr Wohnzimmer nach Hammelburg!
              </p>
            </div>

            {/* Häppchen */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Häppchen für jeden Hunger
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Um Ihr Erlebnis zu vervollständigen, bieten wir eine Snackkarte mit leckeren Gerichten für den großen und kleinen Hunger an. Unser Angebot umfasst leckere Spezialitäten und bietet für jeden Geschmack etwas Passendes.
              </p>
            </div>

            {/* Besuchen Sie uns */}
            <div>
              <h3 className="text-2xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Besuchen Sie uns!
              </h3>
              <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Unser freundliches Team freut sich darauf, Sie herzlich willkommen zu heißen und Ihnen unvergessliche Momente in unserer Cocktail- und Weinbar zu bereiten. Kommen Sie vorbei und genießen Sie die besondere Atmosphäre!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
